// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#questionnaire-detail[data-v-6eca4518]{max-width:1080px;margin-left:auto;margin-right:auto}#questionnaire-detail .box-header .title[data-v-6eca4518]{font-size:22px;font-weight:700}#questionnaire-detail .cancel-btn[data-v-6eca4518]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
